module.exports = __webpack_public_path__ + "static/img/title_img.9b1b90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/dkhd/title_img.png
// module id = dXCU
// module chunks = 1